module.exports = __webpack_public_path__ + "img/desktop_arrow_left.09f62.png";